import { estabelecimento } from "../Estabelecimento/estabelecimento"
import { getUrlAction, sentryError, track } from "../utils";

export var sessionStep = sessionStorage.getItem('ol-step')
if (!sessionStep) {
    sessionStep = 0;
    sessionStorage.setItem('ol-step', sessionStep)
}

export const savesInteraction = (step) => {

    if (step > sessionStep) {
        sessionStep = step;
        sessionStorage.setItem('ol-step', step)
        let urlEmpresa = estabelecimento.urlEmpresa ? estabelecimento.urlEmpresa : localStorage.getItem('urlEmpresa')

        try {
            const localhost = window.location.host.includes('localhost')
            if (!localhost) {
                var steps = ["Abriu cardapio", "Visualizou item", "Adicionou item", "Revisou pedido", "Concluiu pedido"]
                const currentStep = steps[step - 1]
                track(steps[step - 1], { "Estabelecimento": estabelecimento.fantasia, "QRCode": estabelecimento.qrCode.ativo });
                
                if(typeof dataLayer != 'undefined'){
                    dataLayer.push({
                        'event': currentStep,
                    });
                }
            }
        } catch {
            sentryError("Mixpanel")
        }

        $.ajax({
            type: 'POST',
            url: getUrlAction('Home', 'SalvaInteracaoUsuario'),
            data: {
                step: sessionStep,
                urlEmpresa: urlEmpresa
            },
            success: function (response, status, xhr) {


            },
            error: function (e) {

            }
        })
    }

}